import { observer } from "mobx-react";
import PrivateLayout from "layouts/private/private";
import styles from "./styles.module.scss";
import { useAppStore } from "store";
import { useEffect } from "react";
import { getOrderedCarousels } from "helpers/settings.helper";
import CarouselsArray from "components/partial/carousels-array/carousels-array";
import Banner from "components/base/banner/banner";
import { SiteSettingsKeys } from "models/dto/ZoomiLxp/Utilities/Constants/SiteSettingsKeys";
import { ChatModal } from "components/partial/chat-bot/chat-modal";
import { RequestOrigins } from "models/dto/ZoomiLxp/Utilities/Enumerations/RequestOrigins";

export const HomePage = observer(function HomePage() {
	const { usersStore, coursesStore, settingsStore, toasterStore, groupStore, influencersStore, peersStore } =
		useAppStore();
	const sortedCarousels = getOrderedCarousels(settingsStore.publicSettings, "Home.Carousels.Order");
	const userId = usersStore.currentUserInfo!.id;
	const isChatBotEnabledOnHome =
		settingsStore.publicSettings.AITutor?.[SiteSettingsKeys.AITutorEnableHomePage]?.toLowerCase() === "true";

	useEffect(() => {
		Promise.all([
			coursesStore.getAllCoursesByGroups(userId),
			groupStore.getMyGroups(),
			groupStore.getTrendingGroups(),
			groupStore.getPromoGroups(),
			influencersStore.getPromoInfluencers(),
			peersStore.getPromoThreads(),
		]).catch((err) => toasterStore.showErrorMessage(err));
		return () => {
			coursesStore.clearStore();
			groupStore.clearHomeGroups();
			influencersStore.clearPromoInfluencers();
			peersStore.clearPromoThreads();
		};
	}, [toasterStore, coursesStore, groupStore, influencersStore, peersStore, usersStore, userId]);

	return (
		<PrivateLayout>
			<div className={styles.homepage}>
				<Banner
					className={styles.home_banner}
					bannerContentType={settingsStore.publicSettings.Images?.[SiteSettingsKeys.HomeBannerContentType]}
					bannerSrc={settingsStore.publicSettings.Images?.[SiteSettingsKeys.HomeBanner]}
				/>
				<div className={styles.homepage__content}>
					<CarouselsArray carouselsKeys={sortedCarousels} />
				</div>
				{isChatBotEnabledOnHome && <ChatModal userId={userId} origin={RequestOrigins.HomePage} />}
			</div>
		</PrivateLayout>
	);
});
